import {
  INVALIDATE_PROFILE,
  REQUEST_PROFILE,
  RECEIVE_PROFILE,
  SET_GUEST_USER
} from './profile.actions';

export const profileInitialState: IProfileState = {
  entities: {
    profiles: {}
  },
  result: undefined,
  isFetching: false,
  isInvalidated: false
};

export function profileReducer(state = profileInitialState, action: any) {
  switch (action.type) {
    case REQUEST_PROFILE:
      return Object.assign({}, state, {
        isFetching: true
      });
    case RECEIVE_PROFILE:
      const result = action.result;
      return Object.assign({}, state, result, {
        isFetching: false,
        isInvalidated: false
      });
    case INVALIDATE_PROFILE:
      if (state.isFetching) {
        return state;
      } else {
        return Object.assign({}, state, {
          isInvalidated: true
        });
      }
    case SET_GUEST_USER:
      return Object.assign({}, profileInitialState, {
        isInvalidated: false
      });
    default:
      return state;
  }
}

export interface IProfileState {
  isFetching: boolean;
  isInvalidated: boolean;
  entities: {
    profiles: {
      [id: number]: IProfileInstance
    }
  };
  result: number;
}

export interface IProfileInstance {
  id: number;
  userId: number;
  language: string;
  email: string;
  username: string;
  avatarUrl: string;
}
